import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { GET, POST, PUT } from "../../helpers/apiHelper";
import * as action from "./actions";
import { unauthorizeUser } from "../../helpers/utility";

export const getListState = (state) => state.settingApp.list;

const loadSettingAsync = async (query) => GET(`/setting?${query}`);
const loadSettingOneAsync = async () => GET(`/setting`);
const createSettingAsync = async (item) => POST(`/setting`, item, { idempotent: true });
const updateSettingAsync = async (sourcedId, item) => PUT(`/setting/${sourcedId}`, item);

function* loadSettingOne() {
  try {
    const response = yield call(loadSettingOneAsync);
    const data = response?.data ?? null;
    yield put(action.addEditSetting(data, data ? "edit" : "add"));
  } catch (error) {
    yield call(unauthorizeUser(error));
    yield put(action.addEditSetting(null, "add"));
  }
}

function* loadSettingList({ payload }) {
  try {
    const list = yield select(getListState);
    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "orderby",
        value: list.orderBy,
      },
      {
        name: "sortedby",
        value: list.sortedBy,
      },
      {
        name: "limit",
        value: payload.limit,
      },
      {
        name: "municipal_name",
        value: payload.municipal_name,
      }
    ];

    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
        ],
      ];
    }

    const response = yield call(
      loadSettingAsync,
      param.map((t) => `${t.name}=${t.value}`).join("&")
    );
    yield put(action.loadSettingSuccess(response));
  } catch (error) {
    yield call(unauthorizeUser(error));
    yield put(action.loadSettingError(error));
  }
}

function* saveAddEditSetting({ payload }) {
  let response = null;
  try {
    if (payload.item) {
      const payloadStore = {
        sourcedId: payload.item?.sourcedId,
        municipalName: payload.item?.municipalName,
        blobSettingId: payload.item?.blobSettingId,
        apiClientId: payload.item?.apiClientId,
        apiClientSecret: payload.item?.apiClientSecret,
        integrationSetting: payload.item?.integrationSetting,
        activeGigaSchoolSyncType: payload.item?.activeGigaSchoolSyncType,
        entraTenantId: payload.item?.entraTenantId,
        entraClientId: payload.item?.entraClientId,
        entraClientSecret: payload.item?.entraClientSecret,
        entraDefaultDomain: payload.item?.entraDefaultDomain,
        googleTenantId: payload.item?.googleTenantId,
        googleClientId: payload.item?.googleClientId,
        googleClientSecret: payload.item?.googleClientSecret,
        googleAdminEmail: payload.item?.googleAdminEmail,
        googleServiceAccountJson: payload.item?.googleServiceAccountJson,
      };

      if (payload.mode === "add") {
        // CREATE new record - POST /setting
        response = yield call(createSettingAsync, payloadStore);
      } else if (payload.mode === "edit") {
        // UPDATE existing record - PUT /setting/:sourcedId
        response = yield call(updateSettingAsync, payload.item?.sourcedId, payloadStore);
      } else {
        throw new Error("invalid mode");
      }
      
      // Update localStorage municipal if it exists
      const municipalStorage = localStorage.getItem('municipal');
      if (municipalStorage) {
        try {
          const municipal = JSON.parse(municipalStorage);
          if (municipal.hasOwnProperty('activeGigaSchoolSyncType')) {
            municipal.activeGigaSchoolSyncType = payload.item?.activeGigaSchoolSyncType;
            localStorage.setItem('municipal', JSON.stringify(municipal));
          }
        } catch (e) {
          console.error('Error updating localStorage municipal:', e);
        }
      }
      
      yield put(action.saveAddEditSettingSuccess(response));
      yield put(action.loadSettingOne());

      const { history } = payload;
      history.push(`/setting`);
    } else {
      throw new Error("invalid save item, cannot be null");
    }
  } catch (error) {
    yield put(
      action.saveAddEditSettingError(error?.response?.data?.message || error)
    );
  }
}
 
export function* watchLoadSettingList() {
  yield takeEvery(action.SETTING_GET_LIST, loadSettingList);
}

export function* watchLoadSettingOne() {
  yield takeEvery(action.SETTING_LOAD_ONE, loadSettingOne);
}

export function* watchSaveAddEditSetting() {
  yield takeEvery(action.SETTING_SAVE_ADD_EDIT, saveAddEditSetting);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoadSettingList),
    fork(watchLoadSettingOne),
    fork(watchSaveAddEditSetting),
  ]);

}
